import { supabase } from '../supabase';

// Team Board (032) — team_board_posts (migration 031). Viewing goes
// through list_team_board_posts(), not a plain table select — profiles'
// own RLS restricts SELECT to the caller's own row, so a client-side
// embedded join for the author's name would come back null for every
// post the viewer didn't write themselves (same reasoning as
// teamService.listTeamStaff()). Every write goes through a SECURITY
// DEFINER RPC, never a raw insert/update/delete — team_board_posts has
// no INSERT/UPDATE/DELETE RLS policy at all, matching team_events'
// (030) own precedent.

/** Every post for a team, pinned-first then newest-first within each
 * group (already the RPC's own ORDER BY) — with each post's author_name
 * resolved server-side. */
export async function listTeamBoardPosts(teamId) {
  const { data, error } = await supabase.rpc('list_team_board_posts', { p_team_id: teamId });
  if (error) throw error;
  return data;
}

/** Management authority only (Team Admin/Head Coach, or Program Owner/
 * Admin, or platform admin) — create_team_board_post() (031). Rejected
 * server-side once season_status is closeout/ended. created_by is
 * resolved server-side from auth.uid(), never sent from here. category
 * is the raw stored value ('announcement'|'reminder'|'practice_update'|
 * 'achievement'|'other'), never a display label — see utils/
 * teamBoard.js for those. */
export async function createTeamBoardPost({ teamId, category, title, body, isPinned }) {
  const { data, error } = await supabase.rpc('create_team_board_post', {
    p_team_id: teamId,
    p_category: category,
    p_title: title,
    p_body: body,
    p_is_pinned: Boolean(isPinned),
  });
  if (error) throw error;
  return data;
}

/** Same authority/lifecycle rules as createTeamBoardPost() — update_
 * team_board_post() (031). Full editable-field replace (category/title/
 * body/pinned together), not a partial patch. team_id/created_by/
 * created_at can never be changed through this call. */
export async function updateTeamBoardPost({ postId, category, title, body, isPinned }) {
  const { data, error } = await supabase.rpc('update_team_board_post', {
    p_post_id: postId,
    p_category: category,
    p_title: title,
    p_body: body,
    p_is_pinned: Boolean(isPinned),
  });
  if (error) throw error;
  return data;
}

/** Same authority/lifecycle rules — delete_team_board_post() (031).
 * Permanent — Team Board v1 has no soft delete/restore. */
export async function deleteTeamBoardPost(postId) {
  const { error } = await supabase.rpc('delete_team_board_post', { p_post_id: postId });
  if (error) throw error;
}
